module.exports = __webpack_public_path__ + "img/facebook-icon.4d6635ea.svg";